export const addTooltipText = 'Add telecom site';
export const searchTooltipText = 'Search';
export const removeTooltipText = 'Delete this site';
export const editTooltipText = 'Edit this site';
export const viewTooltipText = 'Open site profile';
export const viewOnMapTooltipText = 'View site on map';
export const profilePath = 'site-profile';

export const installedOnAssetOptions = [
	{
		label: 'Yes',
		value: true,
	},
	{
		label: 'No',
		value: false,
	},
];

export const siteOutOfRadiusText = 'The Site is out of the linked Asset radius.';
export const siteCantBeLinkedWarning = 'Warning. Site can’t be linked to the Asset. \n The Site is out of the Asset area.';
export const updateCoordsText = 'Do you want to update the Site coordinates by the Asset coordinates?';
export const updateCoordsAndLinkText = 'Do you want to update the Site coordinates by the Asset coordinates and then link it?';
